import { openUrl } from './openUrl'

const sms = ({ message }: { message: string }) => {
  const url = 'sms:?body=' + encodeURIComponent(message)
  openUrl(url)
}

export default { sms }
